export const formatCurrency = (number) => {
  const formatedCurrency = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(number);

  return "€ " + formatedCurrency.split("€")[0];
};

